import React from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
    return (
        <AuthShell testid="page-forgot" title="Reset your password" sub="Password reset delivery is in placeholder mode. Please contact your admin to reset in Release 1.">
            <div className="border border-border p-6 text-sm text-muted-foreground" data-testid="forgot-placeholder">
                Email-based password reset arrives in Release 2. If you've lost access, contact your organization admin, or in a dev environment ask the platform super admin.
            </div>
            <Link to="/app/login" className="mt-6 inline-flex border border-border px-4 py-2 text-sm hover:bg-secondary" data-testid="forgot-back">Back to login</Link>
        </AuthShell>
    );
}
